/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2022, Zumper
 */

import { useColorModeValue } from '@chakra-ui/react'

interface UseMarkerBg {
  isVisited?: boolean
}

export const useMarkerBg = ({ isVisited }: UseMarkerBg) => {
  const markerBg = useColorModeValue(
    isVisited ? 'neutral.650' : 'blue.800',
    isVisited ? 'pink.600' : 'pink.650'
  )
  return markerBg
}
